import { deduplicate, isDefined } from '@klareospace/pharos-lib-utils';

import type { DataTableColumn } from './data-table';

/** Reorders `columns` by `order` (column keys, untrusted/persisted — deduped) — keys absent from `order` keep their default position, unknown keys are ignored. */
export function applyColumnOrder<T>(columns: DataTableColumn<T>[], order: string[]): DataTableColumn<T>[] {
  if (order.length === 0) {
    return columns;
  }

  const columnByKey = new Map(columns.map((column) => [column.key, column]));
  const dedupedOrder = deduplicate(order);
  const orderedKeys = new Set(dedupedOrder);
  const orderedColumns = dedupedOrder.map((key) => columnByKey.get(key)).filter(isDefined);

  let nextOrderedIndex = 0;
  return columns.map((column) => {
    if (!orderedKeys.has(column.key)) {
      return column;
    }
    const nextColumn = orderedColumns[nextOrderedIndex];
    nextOrderedIndex += 1;
    return nextColumn;
  });
}
